// GENERATED FILE - DO NOT EDIT

// This file has been automatically generated. Any modifications made to this file will be overwritten the next time it is regenerated. Please refrain from editing this file directly.

/** New Caledonia */
const NC = /^(?:(?:[579]\d|8[0-79])\d{4})$/;

export default NC;
